module.exports = "mutation LogoutUser {\n  logoutUser {\n    success\n  }\n}\n"